<template>
  <main class="container">
    <h2>Minhas Carteiras de Pesca</h2>
    <div class="minhas-licencas">
      <LicenseCard
        class="section-card"
        v-for="(license, index) in licenses"
        :key="index"
        :data="license"
      />
      <el-row class="section-card">
        <el-col :span="24" class="license-request">
          <LicenseRequest />
        </el-col>
        <el-col :span="24">
          <PrincipiosBomPescador />
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import LicenseCard from "./LicenseCard.vue";
import LicenseRequest from "./LicenseRequest.vue";
import ConsultaService from "@/services/ConsultaService";
import PrincipiosBomPescador from "./PrincipiosBomPescador.vue";

export default {
  components: { LicenseCard, LicenseRequest, PrincipiosBomPescador },
  data() {
    return {
      licenses: []
    };
  },
  mounted() {
    ConsultaService.consultarMinhaCarteira()
      .then(response => {
        this.licenses = response.data.map(item => ({
          validade: item.licenca.dataVencimento,
          status: item.licenca.status.descricao,
          numero: item.licenca.protocolo.codigoFormatado,
          limite: item.licenca.modalidade.descricaoQtdPeixesLimiteCaptura,
          modalidade: item.licenca.modalidade.nomePT,
          emissao: item.licenca.dataAtivacao,
          qrCode: item.qrCodeBase64,
          protocoloFormatado: item.licenca.protocolo.codigoFormatado,
          mensagemAvisoCarteira: item.mensagemAvisoCarteira
        }));
      })
      .catch(error => {
        console.error("Erro ao consultar carteira:", error);
      });
  }
};
</script>
<style scoped>
.container {
  padding: 25px 29px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: white;
}
.minhas-licencas {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: space-between;
  padding: 0 7px;
}
.section-card {
  flex: 1 1 calc(33.333% - 1.5rem);
  max-width: calc(33.333% - 1.5rem);
  box-sizing: border-box;
}
.license-request {
  display: flex;
}
@media (max-width: 768px) {
  .section-card {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
.request-new {
  width: 300px;
}
.container h2 {
  margin: 0 0 19px 0;
}
</style>
